<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title sliding>{{ $t('gastos.lote_titulo', { total: filas.length }) }}</f7-nav-title>
      <f7-nav-right>
        <f7-button
          fill
          icon-f7="floppy_disk"
          :text="guardando ? $t('gastos.lote_guardando', { hechos: guardados, total: filas.length }) : $t('gastos.lote_guardar_todos')"
          class="display-flex"
          :disabled="guardando || !filas.length"
          @click="guardarTodos"
        ></f7-button>
      </f7-nav-right>
    </f7-navbar>

    <f7-block class="gasto-lote-intro">
      <f7-icon f7="sparkles" size="18"></f7-icon>
      <span>{{ $t('gastos.lote_intro', { total: filas.length }) }}</span>
      <a class="link gasto-lote-foto" @click="verFoto(null)">{{ $t('gastos.lote_ver_foto') }}</a>
    </f7-block>

    <!-- Empleado: el de la sesión. Quien puede dar de alta gastos de otros lo elige arriba para todas
         las líneas y, dentro de cada línea, para una sola. -->
    <f7-block v-if="!veTodos" class="gasto-lote-empleado-fijo">
      <f7-icon f7="person_fill" size="16"></f7-icon> {{ $t('gastos.campos.empleado') }}: <strong>{{ nombreUsuario }}</strong>
    </f7-block>
    <f7-card v-if="veTodos" class="gasto-lote-fila gasto-lote-empleado-todos">
      <f7-card-content>
        <div class="list list-form no-hairlines">
          <f7-row no-gap>
            <f7-col width="100" medium="50">
              <r-autocomplete
                outline
                :dbAdapter="Empleado"
                class="col-100"
                floating-label
                :label="$t('gastos.lote_empleado_todos')"
                :form="formTodos"
                name="username"
                labelProp="nombre"
                idProp="username"
                prefixProp="username"
                :shownFields="['username', 'nombre']"
                :async="true"
                :minLength="2"
                :onchange="empleadoParaTodas"
              ></r-autocomplete>
            </f7-col>
            <f7-col width="100" medium="50" class="gasto-lote-empleado-nota">
              {{ $t('gastos.lote_empleado_nota') }}
            </f7-col>
          </f7-row>
        </div>
      </f7-card-content>
    </f7-card>

    <f7-card v-for="(fila, i) in filas" :key="fila.clave" class="gasto-lote-fila" :class="{ 'gasto-lote-fila-error': fila.error, 'gasto-lote-fila-ok': fila.id }">
      <f7-card-content>
        <div class="gasto-lote-cuerpo">
          <!-- Recorte del ticket -->
          <div class="gasto-lote-recorte" @click="verFoto(fila)">
            <img v-if="fila.miniatura" :src="fila.miniatura" :alt="fila.datos.establecimiento || 'ticket'" />
            <div v-else class="gasto-lote-sin-recorte"><f7-icon f7="doc_text"></f7-icon></div>
            <span class="gasto-lote-num">{{ i + 1 }}</span>
          </div>

          <!-- Datos editables -->
          <div class="gasto-lote-datos list list-form no-hairlines">
            <f7-row no-gap>
              <f7-col width="50" medium="20">
                <!-- :key ligada al nº de opciones: el select nativo no repinta el valor leído cuando las opciones llegan después (mismo apaño que en gasto-form). -->
                <f7-list-input :key="'tipo-' + catalogos.tiposDocumento.length" outline floating-label :label="$t('gastos.campos.tipoDocumento')" type="select" :value="fila.datos.tipoDocumento" :disabled="!!fila.id" @change="fila.datos.tipoDocumento = $event.target.value">
                  <option v-for="t in catalogos.tiposDocumento" :key="t.codigo" :value="t.codigo">{{ t.nombre }}</option>
                </f7-list-input>
              </f7-col>
              <f7-col width="50" medium="20">
                <f7-list-input :key="'cat-' + catalogos.categorias.length" outline floating-label :label="$t('gastos.campos.categoria')" type="select" :value="fila.datos.categoria" :disabled="!!fila.id" @change="fila.datos.categoria = $event.target.value">
                  <option v-for="c in catalogos.categorias" :key="c.codigo" :value="c.codigo">{{ c.nombre }}</option>
                </f7-list-input>
              </f7-col>
              <f7-col width="50" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.fecha')" :disabled="!!fila.id" type="date" :value="fila.datos.fecha" @input="fila.datos.fecha = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="50" medium="15">
                <f7-list-input outline floating-label :label="$t('gastos.campos.hora')" :disabled="!!fila.id" type="text" placeholder="HH:mm" :value="fila.datos.hora" @input="fila.datos.hora = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="100" medium="25">
                <f7-list-input outline floating-label class="gasto-lote-total" :label="$t('gastos.campos.importeTotal')" :disabled="!!fila.id" type="number" step="0.01" :value="fila.datos.importeTotal" @input="fila.datos.importeTotal = $event.target.value"></f7-list-input>
              </f7-col>

              <f7-col width="100" medium="40">
                <f7-list-input outline floating-label :label="$t('gastos.campos.establecimiento')" :disabled="!!fila.id" type="text" :value="fila.datos.establecimiento" @input="fila.datos.establecimiento = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="50" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.cif')" :disabled="!!fila.id" type="text" :value="fila.datos.cif" @input="fila.datos.cif = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="50" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.numeroFactura')" :disabled="!!fila.id" type="text" :value="fila.datos.numeroFactura" @input="fila.datos.numeroFactura = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="50" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.matricula')" :disabled="!!fila.id" type="text" :value="fila.datos.matricula" @input="fila.datos.matricula = $event.target.value.toUpperCase()"></f7-list-input>
              </f7-col>
              <f7-col width="50" medium="20">
                <!-- Mismo autocompletado que el formulario: el gasto viaja con el idExpediente resuelto, no solo con el código tecleado. -->
                <r-autocomplete
                  outline
                  :dbAdapter="Inspeccion"
                  class="col-100"
                  floating-label
                  :label="$t('gastos.campos.codigoExpediente')"
                  :form="fila.form"
                  name="codigoExpediente"
                  labelProp="codigo"
                  idProp="codigo"
                  :shownFields="['id', 'codigo', 'cliente.razonSocial']"
                  :async="true"
                  :minLength="3"
                  :readonly="!!fila.id"
                  :onchange="onExpedienteFila(fila)"
                ></r-autocomplete>
              </f7-col>
              <f7-col v-if="veTodos" width="100" medium="40">
                <r-autocomplete
                  outline
                  :dbAdapter="Empleado"
                  class="col-100"
                  floating-label
                  :label="$t('gastos.campos.empleado')"
                  :form="fila.form"
                  name="username"
                  labelProp="nombre"
                  idProp="username"
                  prefixProp="username"
                  :shownFields="['username', 'nombre']"
                  :async="true"
                  :minLength="2"
                  :readonly="!!fila.id"
                ></r-autocomplete>
              </f7-col>

              <f7-col width="33" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.baseImponible')" :disabled="!!fila.id" type="number" step="0.01" :value="fila.datos.baseImponible" @input="fila.datos.baseImponible = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="33" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.iva')" :disabled="!!fila.id" type="number" step="0.01" :value="fila.datos.iva" @input="fila.datos.iva = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="34" medium="20">
                <f7-list-input outline floating-label :label="$t('gastos.campos.tipoIva')" :disabled="!!fila.id" type="number" step="1" :value="fila.datos.tipoIva" @input="fila.datos.tipoIva = $event.target.value"></f7-list-input>
              </f7-col>
              <f7-col width="100" medium="40">
                <f7-list-input outline floating-label :label="$t('gastos.campos.datosEstablecimiento')" :disabled="!!fila.id" type="textarea" resizable :value="fila.datos.datosEstablecimiento" @input="fila.datos.datosEstablecimiento = $event.target.value"></f7-list-input>
              </f7-col>
            </f7-row>

            <div class="gasto-lote-pie">
              <span v-if="fila.reconocimiento && fila.reconocimiento.aviso" class="gasto-lote-aviso">
                <f7-icon f7="exclamationmark_triangle" size="14"></f7-icon> {{ fila.reconocimiento.aviso }}
              </span>
              <span v-if="fila.error" class="gasto-lote-error">{{ fila.error }}</span>
              <span v-if="fila.id" class="gasto-lote-guardado"><f7-icon f7="checkmark_seal_fill" size="14"></f7-icon> {{ $t('gastos.lote_guardado') }}</span>
              <a v-if="!fila.id && !guardando" class="link color-red gasto-lote-quitar" @click="quitar(i)">
                <f7-icon f7="trash" size="16"></f7-icon> {{ $t('gastos.lote_quitar') }}
              </a>
            </div>
          </div>
        </div>
      </f7-card-content>
    </f7-card>

    <f7-block v-if="!filas.length" class="text-align-center">
      <p>{{ $t('gastos.lote_vacio') }}</p>
      <f7-button fill @click="$f7router.navigate('/gastos/', { reloadCurrent: true })">{{ $t('gastos.gastos') }}</f7-button>
    </f7-block>

    <!-- Foto entera o recorte, movible para cotejar -->
    <f7-popup v-arrastrable :opened="fotoAbierta" @popup:closed="cerrarFoto" class="gasto-lote-popup" :backdrop="false" :close-by-backdrop-click="false">
      <f7-page>
        <f7-navbar :title="fotoTitulo">
          <f7-nav-right><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-right>
        </f7-navbar>
        <div class="gasto-lote-popup-img"><img v-if="fotoUrl" ref="fotoImg" :src="fotoUrl" /></div>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<style scoped>
.gasto-lote-intro {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 16px 4px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f1faf4;
  border: 1px solid #b7e4c7;
  font-size: 13px;
  color: #146c43;
}
.gasto-lote-foto { margin-left: auto; font-size: 12px; white-space: nowrap; }
.gasto-lote-fila { margin: 8px 16px; }
.gasto-lote-empleado-todos { border-left: 4px solid #23355b; }
.gasto-lote-empleado-fijo { display: flex; align-items: center; gap: 6px; margin: 4px 16px; font-size: 13px; color: #23355b; }
.gasto-lote-empleado-nota { font-size: 12px; color: #5b6573; display: flex; align-items: center; padding: 0 12px; }
.gasto-lote-fila-error { border-left: 4px solid #b02a37; }
.gasto-lote-fila-ok { border-left: 4px solid #146c43; opacity: 0.85; }
.gasto-lote-cuerpo { display: flex; gap: 14px; align-items: flex-start; }
.gasto-lote-recorte {
  position: relative;
  flex: 0 0 120px;
  height: 160px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  background: #f6f8fb;
  overflow: hidden;
  cursor: zoom-in;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gasto-lote-recorte img { max-width: 100%; max-height: 100%; object-fit: contain; }
.gasto-lote-sin-recorte { color: #9e9e9e; font-size: 28px; }
.gasto-lote-num {
  position: absolute;
  top: 4px;
  left: 4px;
  background: #23355b;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 7px;
}
.gasto-lote-datos { flex: 1; min-width: 0; }
.gasto-lote-pie {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 4px;
  font-size: 12px;
}
.gasto-lote-aviso { color: #9a6700; }
.gasto-lote-error { color: #b02a37; font-weight: 600; }
.gasto-lote-guardado { color: #146c43; font-weight: 600; }
.gasto-lote-quitar { margin-left: auto; font-size: 12px; }
::v-deep .gasto-lote-total input { font-weight: 700; }
/* Con zoom (rueda, pellizco, arrastre; ver js/utils/zoomImagen.js): la imagen ampliada se recorta y se recorre arrastrando. */
.gasto-lote-popup-img { width: 100%; height: calc(100% - 44px); overflow: hidden; display: flex; align-items: center; justify-content: center; background: #eceff1; }
.gasto-lote-popup-img img { max-width: 100%; max-height: 100%; object-fit: contain; transform-origin: center center; }
</style>

<script>
import rAutocomplete from "./../../components/rAutocomplete.vue";
import Gasto from "./../../js/db/Gasto.js";
import Documento from "./../../js/db/Documento.js";
import Empleado from "./../../js/db/Empleado.js";
import Inspeccion from "./../../js/db/Inspeccion.js";
import Utils from "./../../js/Utils.js";
import zoomImagen from "./../../js/utils/zoomImagen.js";
import moment from "moment";

/**
 * Alta en lote: una foto con varios tickets. El servidor ya ha leído cada uno y subido su recorte;
 * aquí sale una línea por ticket con sus datos editables y un solo «Guardar todos» que crea un
 * gasto por línea. Lo que viene de la IA viaja tal cual en `reconocimiento` (firmado) y el
 * servidor anota lo que se corrija.
 */
const CAMPOS_IA = ["tipoDocumento", "fecha", "hora", "establecimiento", "datosEstablecimiento", "cif",
  "numeroFactura", "matricula", "baseImponible", "iva", "tipoIva", "importeTotal", "moneda", "categoria"];

/**
 * rAutocomplete espera un rForm; aquí cada línea tiene sus datos sueltos, así que se le da un
 * objeto con lo justo: formData (los datos de la línea), errors, readonly, username y un $emit
 * que no hace nada. Las demás propiedades que consulta (history, user...) las tolera a null.
 */
function formDe(formData, usuario) {
  return {
    formData: formData,
    errors: {},
    readonly: false,
    username: usuario,
    history: null,
    historyBulk: null,
    user: null,
    dbAdapter: null,
    validateFields: function() {},
    $emit: function() {}
  };
}

export default {
  components: {
    rAutocomplete
  },
  data: function() {
    const user = Utils.getUser() || {};
    return {
      usuario: user.username || "",
      nombreUsuario: user.nombre || user.username || "",
      Empleado,
      Inspeccion,
      veTodos: false,
      formTodos: formDe({ username: user.username || "" }, user.username || ""),
      catalogos: { categorias: [], tiposDocumento: [] },
      filas: [],
      fotoOriginal: null,
      guardando: false,
      guardados: 0,
      fotoAbierta: false,
      fotoUrl: null,
      fotoTitulo: ""
    };
  },
  mounted: function() {
    const self = this;
    const lote = Gasto.tomarLote();
    if (!lote || !lote.tickets || !lote.tickets.length) {
      self.$f7router.navigate("/gastos/", { reloadCurrent: true });
      return;
    }
    self.fotoOriginal = lote.foto || null;
    self.filas = lote.tickets.map(function(t, i) {
      return self.filaDe(t, i);
    });
    Gasto.catalogos()
      .then(function(c) {
        self.catalogos = { categorias: c.categorias || [], tiposDocumento: c.tiposDocumento || [] };
        self.veTodos = !!c.veTodos;
      })
      .catch(function(e) {
        console.error("No se han podido cargar los catálogos de gastos", e);
      });
  },
  methods: {
    filaDe: function(ticket, i) {
      const rec = ticket.reconocimiento || {};
      const d = rec.datos || {};
      const datos = {};
      CAMPOS_IA.forEach(function(campo) {
        const v = d[campo];
        datos[campo] = v === undefined || v === null ? "" : String(v);
      });
      datos.tipoDocumento = (datos.tipoDocumento || "TICKET").toUpperCase();
      datos.categoria = (datos.categoria || "OTROS").toUpperCase();
      datos.moneda = (datos.moneda || "EUR").toUpperCase();
      datos.codigoExpediente = "";
      datos.idExpediente = null;
      datos.username = this.usuario;
      // Sin recorte propio (foto con un formato que no se recorta): todos comparten la foto entera.
      const documento = ticket.documento && ticket.documento.path ? ticket.documento : this.fotoOriginal;
      return {
        clave: "t" + i + "-" + Date.now(),
        form: formDe(datos, this.usuario),
        reconocimiento: rec,
        documento: documento,
        // La foto local aún sin subir lleva `_base64` Y un `path` que es solo la carpeta de destino:
        // manda el `_base64`; solo un documento ya en el servidor (sin `_base64`) se pide escalado.
        miniatura: documento && documento._base64 ? documento._base64 : (documento && documento.path ? Documento.getDocumentoScaledUrl(documento) : null),
        datos: datos,
        id: null,
        error: null,
        idLocal: "local-" + Date.now() + "-" + i + "-" + Math.floor(Math.random() * 1e6)
      };
    },
    numero: function(v) {
      if (v === "" || v === null || v === undefined) return null;
      const n = Number(String(v).replace(",", "."));
      return Number.isFinite(n) ? n : null;
    },
    gastoDe: function(fila) {
      const d = fila.datos;
      const fecha = d.fecha ? moment(d.fecha, ["YYYY-MM-DD", "DD/MM/YYYY"]).toDate() : null;
      return {
        username: d.username || this.usuario,
        tipoDocumento: d.tipoDocumento,
        categoria: d.categoria,
        fecha: fecha,
        hora: d.hora || null,
        establecimiento: d.establecimiento || null,
        datosEstablecimiento: d.datosEstablecimiento || null,
        cif: d.cif ? d.cif.toUpperCase() : null,
        numeroFactura: d.numeroFactura || null,
        matricula: d.matricula ? d.matricula.toUpperCase().replace(/[^A-Z0-9]/g, "") : null,
        baseImponible: this.numero(d.baseImponible),
        iva: this.numero(d.iva),
        tipoIva: this.numero(d.tipoIva),
        importeTotal: this.numero(d.importeTotal),
        moneda: d.moneda || "EUR",
        codigoExpediente: d.codigoExpediente || null,
        // El id solo vale si sigue habiendo código: el aspa del autocompletado vacía el código sin onchange.
        idExpediente: d.codigoExpediente ? d.idExpediente || null : null,
        documentos: fila.documento ? [fila.documento] : [],
        reconocimiento: fila.reconocimiento,
        origen: process.env.TARGET === "cordova" ? "CORDOVA" : "WEB",
        idLocal: fila.idLocal
      };
    },
    validar: function(fila) {
      const d = fila.datos;
      if (!fila.documento) return this.$t("gastos.foto_obligatoria");
      if (!d.fecha) return this.$t("gastos.fecha_obligatoria");
      const total = this.numero(d.importeTotal);
      if (!total || total <= 0) return this.$t("gastos.total_obligatorio");
      return null;
    },
    /** Guarda las filas pendientes una a una; las que fallan se quedan con su error y se pueden reintentar. */
    guardarTodos: function() {
      const self = this;
      const app = self.$f7;
      const pendientes = self.filas.filter(function(f) { return !f.id; });
      if (!pendientes.length) return;
      self.guardando = true;
      self.guardados = self.filas.length - pendientes.length;
      const unaAUna = function(i) {
        if (i >= pendientes.length) {
          self.guardando = false;
          const fallidas = self.filas.filter(function(f) { return !f.id; }).length;
          if (!fallidas) {
            app.toast.create({ text: self.$t("gastos.lote_todos_guardados", { total: self.filas.length }), position: "center", closeTimeout: 2500, icon: '<i class="f7-icons">checkmark_alt</i>' }).open();
            self.$f7router.navigate("/gastos/", { reloadCurrent: true });
          } else {
            app.dialog.alert(self.$t("gastos.lote_con_errores", { fallidas: fallidas }));
          }
          return;
        }
        const fila = pendientes[i];
        if (self.filas.indexOf(fila) === -1) {
          // Quitada del lote mientras se guardaban las anteriores: no se crea su gasto.
          unaAUna(i + 1);
          return;
        }
        const error = self.validar(fila);
        if (error) {
          fila.error = error;
          unaAUna(i + 1);
          return;
        }
        fila.error = null;
        // Un documento subido por el servidor (recorte) ya tiene path y no se vuelve a subir; la
        // foto entera con _base64 sí se sube una vez y se reutiliza en las filas que la comparten.
        // La referencia original se guarda ANTES de sustituirla: el forEach cambia también la de esta
        // fila en su propia vuelta y, comparando contra `fila.documento`, las siguientes ya no
        // coincidían y volvían a subir la foto entera.
        const documentoOriginal = fila.documento;
        // `_base64` es lo que dice que la foto aún no está en el servidor: el `path` de la foto local es
        // solo la carpeta de destino (lo pone gastos.vue), así que no sirve para distinguirla.
        const subida = documentoOriginal && documentoOriginal._base64
          ? Documento.uploadData(Object.assign({ base64: documentoOriginal._base64 }, documentoOriginal)).then(function(res) {
              const doc = res.list ? res.list[0] : res;
              self.filas.forEach(function(f) { if (f.documento === documentoOriginal) f.documento = doc; });
              fila.documento = doc;
            })
          : Promise.resolve();
        subida
          .then(function() { return Gasto.save({ data: self.gastoDe(fila) }); })
          .then(function(res) {
            fila.id = res && res.id ? res.id : "ok";
            self.guardados += 1;
            unaAUna(i + 1);
          })
          .catch(function(e) {
            fila.error = (e && (e.message || e.error)) || self.$t("gastos.lote_error_generico");
            unaAUna(i + 1);
          });
      };
      unaAUna(0);
    },
    /** Expediente elegido en una línea: se guarda su id junto al código, como hace el formulario. */
    onExpedienteFila: function(fila) {
      const self = this;
      return function(componente) {
        return function(value) {
          const item = value && value[0];
          componente.setValue(item);
          self.$set(fila.datos, "idExpediente", item && item.id ? item.id : null);
        };
      };
    },
    /** El empleado elegido arriba se pone en todas las líneas que aún no se han guardado. */
    empleadoParaTodas: function(componente) {
      const self = this;
      return function(value) {
        const item = value && value[0];
        componente.setValue(item || {});
        const username = item && item.username;
        if (!username) return;
        self.filas.forEach(function(f) {
          if (!f.id) self.$set(f.datos, "username", username);
        });
      };
    },
    quitar: function(i) {
      const self = this;
      if (self.guardando) return;
      const fila = self.filas[i];
      self.$f7.dialog.confirm(self.$t("gastos.lote_quitar_confirmar"), self.$t("gastos.lote_quitar"), function() {
        // Por referencia y no por índice: si entre el clic y el «Aceptar» cambió la lista
        // (o ya se guardó), no se quita otra fila.
        if (self.guardando || fila.id) return;
        const pos = self.filas.indexOf(fila);
        if (pos !== -1) self.filas.splice(pos, 1);
      });
    },
    verFoto: function(fila) {
      const doc = fila ? fila.documento : this.fotoOriginal;
      if (!doc) return;
      this.fotoTitulo = fila ? (fila.datos.establecimiento || this.$t("gastos.lote_recorte")) : this.$t("gastos.lote_foto_original");
      this.fotoUrl = doc._base64 || (doc.path ? Documento.getDocumentoPublicUrl(doc) : null);
      this.fotoAbierta = !!this.fotoUrl;
      // El <img> va con v-if: existe en el siguiente repintado. Si ya estaba (se cambia de foto con el
      // popup abierto) engancharZoom no hace nada y el cambio de src la deja ajustada.
      this.$nextTick(() => this.engancharZoom());
    },
    cerrarFoto: function() {
      this.fotoAbierta = false;
      this.soltarZoom();
    },
    /** Zoom de la foto del popup (rueda, pellizco, arrastre y doble toque). */
    engancharZoom: function() {
      const img = this.$refs.fotoImg;
      if (this._zoomImagen && this._zoomImagen.img === img) return;
      this.soltarZoom();
      if (!img) return;
      this._zoomImagen = { img: img, zoom: zoomImagen(img) };
    },
    soltarZoom: function() {
      if (this._zoomImagen) {
        this._zoomImagen.zoom.destruir();
        this._zoomImagen = null;
      }
    }
  },
  beforeDestroy: function() {
    this.soltarZoom();
  }
};
</script>
